// 🚨 Initialize Sentry FIRST (before any other imports)
import { initSentry } from './config/sentry.config';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import './utils/getFirebaseToken'; // Make getFirebaseToken available globally

// Initialize Sentry after imports
initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  const registerSW = () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        if (process.env.NODE_ENV === 'development') {
          console.log('Service Worker registered:', registration.scope);
        }
        registration.addEventListener('updatefound', () => {});
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
        console.error('This will prevent the PWA install prompt from appearing automatically.');
      });
  };
  // In standalone PWA, register immediately so SW is ready when user enables push (no wait for load).
  const isStandalone = typeof window !== 'undefined' &&
    (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true);
  if (isStandalone) {
    registerSW();
  } else {
    window.addEventListener('load', registerSW);
  }
} else {
  console.warn('⚠️ Service Workers not supported in this browser. PWA installation may not work.');
}